import { render, staticRenderFns } from "./PetGeneralInfo.vue?vue&type=template&id=ebb68d0a&scoped=true&"
import script from "./PetGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./PetGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./PetGeneralInfo.vue?vue&type=style&index=0&id=ebb68d0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb68d0a",
  null
  
)

export default component.exports